<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Settings</div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="saveSettings"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  size="xs"
                ></q-icon>
              </q-btn>
              <q-btn
                class="q-ml-md"
                no-caps
                flat
                unelevated
                @click="toggleDarkMode"
              >
                <q-icon name="mdi-brightness-6" size="xs"></q-icon>
              </q-btn>

              <q-space />
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div class="row" v-if="formData">
              <div class="col-12">
                <div class="inputSettingsPlayground">
                  <q-input
                    label="Test"
                    v-bind="formData.fields.general"
                    v-model="text"
                  ></q-input>
                  <q-toggle
                    class="fieldToggle"
                    label="Filled"
                    v-model="formData.fields.general.filled"
                  />
                  <q-toggle
                    class="fieldToggle"
                    label="Outlined"
                    v-model="formData.fields.general.outlined"
                  />
                  <q-toggle
                    class="fieldToggle"
                    label="Borderless"
                    v-model="formData.fields.general.borderless"
                  />
                  <q-toggle
                    class="fieldToggle"
                    label="Standout"
                    v-model="formData.fields.general.standout"
                  />
                  <q-toggle
                    class="fieldToggle"
                    label="Rounded"
                    v-model="formData.fields.general.rounded"
                  />
                  <q-toggle
                    class="fieldToggle"
                    label="Square"
                    v-model="formData.fields.general.square"
                  />
                  <q-toggle
                    class="fieldToggle"
                    label="Dense"
                    v-model="formData.fields.general.dense"
                  />
                </div>
              </div>
              <div class="col-12"></div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        cfg: "settings/siteCFG",
      }),
    },
    watch: {
      cfg: function () {
        this.init();
      },
    },
    data: () => ({
      text: "",
      formData: null,
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.formData = JSON.parse(JSON.stringify(this.cfg));
      },
      saveSettings() {
        this.$store.dispatch("settings/updateConfig", this.formData);
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: "Settings Saved",
        });
      },
      toggleDarkMode() {
        this.$q.dark.toggle();
        this.$store.dispatch("settings/changeDarkMode", this.$q.dark.isActive);
      },
    },
  };
</script>

<style lang="scss" scope>
  .inputSettingsPlayground {
    max-width: 600px;
    margin: auto;

    .fieldToggle {
      width: 140px;
    }
  }

  .formHeight {
    min-height: calc(100vh - 215px);
    max-height: 1000px;
  }
</style>
